// extracted by mini-css-extract-plugin
export var container = "_7s-0";
export var containerTopRight = "_7s-1";